import styled from 'styled-components';

export const ResponsiveModalContent = styled.div`
  width: 95%;
  max-width: 700px;
  margin: 0 auto;
`;

export const ResponsiveForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ResponsiveFormGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  & > * {
    flex: 1 1 200px;
    min-width: 150px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const DatePickerWrapper = styled.div`
  width: 100%;

  .field {
    width: 100%;
  }
`;

export const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }

  .field {
    width: 100%;
  }
`;

export const DueDateLabel = styled.label`
  display: block;
  margin: 0em 0em 0.28571429rem 0em;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.92857143em;
  font-weight: bold;
  text-transform: none;
`;
